import { render, staticRenderFns } from "./CampusGradeList.vue?vue&type=template&id=6d2be777"
import script from "../../controllers/campus_grade/campus-grade-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus_grade/campus-grade-list.js?vue&type=script&lang=js&external"
import style0 from "./CampusGradeList.vue?vue&type=style&index=0&id=6d2be777&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports